import Accordion from "@/common/components/Accordion"
import Checkbox from "@/common/components/Checkbox"
import { ImageCarousel } from "@/common/components/ImageCarousel"
import { ImageWithPlaceholder } from "@/common/components/ImageWithPlaceholder"
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type"
import { ImageOffIcon } from "lucide-react"
import AccreditationCASection from "./AccreditationCASection"
import AccreditationCMSection from "./AccreditationCMSection"
import MaintenanceRequiredDocumentsSection from "./MaintenanceRequiredDocumentsSection"
import UpdateAccreditationInformation from "./UpdateAccreditationInformation"

interface AccreditationSectionProps {
  establishmentCompany?: EstablishmentCompanyData;
  establishmentCompanyIsLoading?: boolean;
  disabled?: boolean;
}

const AccreditationSection = ({ establishmentCompany, establishmentCompanyIsLoading, disabled }: AccreditationSectionProps) => {
  return (
    <>
      <Accordion
        className="p-0"
        triggerClassName="p-4"
        bodyClassName="p-4 pt-0"
        defaultOpen
        head={(
          <div className="flex items-center gap-3">
            <div onClick={(event) => {
              event.stopPropagation();
            }}>
              <UpdateAccreditationInformation
                establishmentCompany={establishmentCompany}
                establishmentCompanyIsLoading={establishmentCompanyIsLoading}
                disabled={disabled}
              />
            </div>

            <p className="text-lg font-bold">
              Dados de credenciamento
            </p>
          </div>
        )}
        body={(
          <div className="flex flex-col gap-4">
            <div className="flex gap-4">
              <div className="flex-1 flex flex-col gap-4">
                <div className="flex flex-col gap-1.5">
                  <p className="text-xs">
                    Sistemas habilitados
                  </p>

                  <div className="flex flex-col gap-3">
                    <Checkbox
                      checked={establishmentCompany?.ca_module_enabled}
                      label="Controle de abastecimento (CA)"
                      className="cursor-default"
                    />

                    <Checkbox
                      checked={establishmentCompany?.cm_module_enabled}
                      label="Controle de manutenção (CM)"
                      className="cursor-default"
                    />

                    <Checkbox
                      checked={establishmentCompany?.tmais_module_enabled}
                      label="Taurus + (T+)"
                      className="cursor-default"
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-1.5">
                  <p className="text-xs">
                    Realiza coleta/guincho de equipamento?
                  </p>

                  <div className="flex items-center gap-2">
                    <Checkbox
                      type="radio"
                      label="Sim"
                      className="items-center gap-1.5 cursor-default"
                      boxClassName="rounded-full size-6"
                      checked={!!establishmentCompany?.tow_service_available}
                    />

                    <Checkbox
                      type="radio"
                      label="Não"
                      className="items-center gap-1.5 cursor-default"
                      boxClassName="rounded-full size-6"
                      checked={!establishmentCompany?.tow_service_available}
                    />
                  </div>
                </div>
              </div>

              <ImageCarousel
                showExpandButton
                showNavigationButtons
                showRemoveButton={false}
                files={establishmentCompany?.matrix_branch?.photos.map(photo => ({
                  id: photo.id,
                  file: photo?.url,
                })) || []}
                Placeholder={(
                  <ImageWithPlaceholder
                    className="size-72 rounded-lg bg-white-100"
                    iconClassName="size-32 text-gray-400"
                    placeholderIcon={ImageOffIcon}
                  />
                )}
              />
            </div>
          </div>
        )}
      />

      {establishmentCompany?.ca_module_enabled && (
        <AccreditationCASection
          establishmentCompany={establishmentCompany}
          disabled={disabled}
        />
      )}

      {establishmentCompany?.cm_module_enabled && (
        <AccreditationCMSection
          establishmentCompany={establishmentCompany}
          disabled={disabled}
        />
      )}

      <MaintenanceRequiredDocumentsSection
        establishmentCompany={establishmentCompany}
        disabled={disabled}
      />
    </>
  );
}

export default AccreditationSection
